import React from "react";
import EditItemName from "modules/Common/Components/EditItemName";
import styled from "styled-components";

interface IStickyHeaderContentWithBackButtonProps {
  fieldName?: string;
  hideBack?: boolean;
  itemName?: string;
  itemTitle?: string;
  loading?: boolean;
  nonEditable?: boolean;
  editNameSubmitHandler?: (value: any) => void;
  showCircle?: boolean;
  editionStatus?: string;
  assetId?: number;
  campaignName?: string;
  workflowName?: string;
  page?: string;
  firstColumnSpan?: number;
  secondColumnSpan?: number;
  goBackURL?: string;
  goBackFunction?: any;
  saveNewListName?: (value: any) => void;
  commasNotAllowed?: boolean;
  disableBackButton?: boolean;
  workflowId?: number
  emailId?: number
  tab?: string
  isDigestFlag?: boolean;
}
const StickyHeaderContentWithBackButton: React.FC<IStickyHeaderContentWithBackButtonProps> = ({
  fieldName,
  hideBack,
  itemName,
  itemTitle,
  loading,
  nonEditable,
  editNameSubmitHandler,
  children,
  showCircle,
  editionStatus,
  assetId,
  campaignName,
  workflowName,
  page,
  goBackURL,
  goBackFunction,
  saveNewListName,
  commasNotAllowed,
  disableBackButton,
  workflowId,
  emailId,
  tab,
  isDigestFlag
}) => {
  return (
    <StickyHeaderContentContainer>
      <div
        className={`d-flex justify-content-between full-width ${window.location.pathname.endsWith("/source") ? " header-sub-label" : ""
          }`}
      >
        <div
          className={`label-container flex-grow-1 ${window.location.pathname.endsWith("/source") ? " flex-column align-items-start" : ""
            }`}
        >
          <div className="w-100">
            <EditItemName
              fieldName={fieldName}
              hideBack={hideBack}
              itemName={itemName}
              itemTitle={itemTitle}
              loading={loading}
              nonEditable={nonEditable}
              submitHandler={saveNewListName ? saveNewListName : editNameSubmitHandler}
              editionStatus={editionStatus}
              showCircle={showCircle}
              assetId={assetId}
              campaignName={campaignName}
              workflowName={workflowName}
              page={page}
              goBackURL={goBackURL}
              tooltipPlacement={"bottom"}
              goBackFunction={goBackFunction}
              commasNotAllowed={commasNotAllowed}
              disableBackButton={disableBackButton}
              workflowId={workflowId}
              emailId={emailId}
              tab={tab}
              isDigestFlag={isDigestFlag}
            />
          </div>
          {window.location.pathname.endsWith("/source") && (
            <span className="sub-label-header">Search, select and drag content to create emails</span>
          )}
        </div>
        <div>{children}</div>
      </div>
    </StickyHeaderContentContainer>
  );
};

export default StickyHeaderContentWithBackButton;

const StickyHeaderContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  .full-width {
    width: 100%;
    justify-content: space-between;
    &.header-sub-label {
      padding-top: 31px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding-top: 16px;
      }
      .label-container {
        padding-top: 5px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding-top: 7px;
        }
        + div {
          margin-top: 2px;
        }
      }
    }
  }
  .label-container {
    display: flex;
    justify-content: start;
    height: 100%;
    align-items: center;
    .email-name {
      /* max-width: 475px; */
      max-width: calc(100vw - 1000px) !important;
      
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: calc(100vw - 750px) !important;
      }
    }
  }
  .sub-label-header {
    color: #424b50;
    font-size: 16px;
    font-weight: 600;
    line-height: 47px;
    margin-bottom: 0px;
    display: block;
    font-family: "Roboto Slab", serif;
    white-space: nowrap;
    margin-top: -10px;
    margin-left: 50px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 33px;
      margin-left: 38px;
    }
  }
  .tabs-justified-center {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
  }
  .styling-tag-green {
    /* border: 1px solid #dadada;
    color: #09a43a; */
    background-color: rgb(222, 246, 230);
  }
`;
